
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[state_slug]",
      function () {
        return require("private-next-pages/[state_slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[state_slug]"])
      });
    }
  